import React, { useState } from "react";
import { FileText, ShieldCheck } from "lucide-react";
import api, { formatError, API } from "@/lib/api";
import { fmtEuro } from "@/lib/status";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";

export const AcceptanceGate = ({ data, onAccepted }) => {
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const a = data.acceptance;

  const accept = async () => {
    setBusy(true); setError("");
    try {
      const { data: res } = await api.post(`/public/tracking/${data.public_token}/accept-terms`);
      onAccepted(res);
    } catch (e) { setError(formatError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/70 p-4 backdrop-blur-sm sm:items-center" data-testid="acceptance-gate">
      <div className="max-h-[90vh] w-full max-w-lg overflow-y-auto rounded-2xl border border-white/10 bg-slate-900 p-6 text-white">
        <div className="flex items-center gap-2 text-primary"><ShieldCheck className="h-5 w-5" />
          <span className="text-xs font-semibold uppercase tracking-wider">Modulo di accettazione</span></div>
        <h2 className="mt-2 font-heading text-xl font-extrabold">Per proseguire accetta i termini del modulo di accettazione</h2>
        <div className="mt-4 space-y-2 rounded-xl bg-white/5 p-4 text-sm">
          <Row label="Pratica" value={data.repair_number} />
          <Row label="Cliente" value={a.customer} />
          <Row label="Dispositivo" value={a.device} />
          {a.imei && <Row label="IMEI / Seriale" value={a.imei} />}
          <Row label="Problema" value={a.problem || "—"} />
        </div>
        <div className="mt-4 rounded-xl bg-white/5 p-4 text-sm" data-testid="acceptance-quote">
          <div className="mb-2 text-xs uppercase tracking-wider text-slate-400">Preventivo</div>
          {a.quote ? (
            <>
              {a.quote.items.map((it, i) => (
                <div key={i} className="flex justify-between gap-3"><span>{it.description}</span><span className="whitespace-nowrap">{fmtEuro(it.total)}</span></div>
              ))}
              <div className="mt-2 flex justify-between border-t border-white/10 pt-2 font-bold"><span>Totale</span><span>{fmtEuro(a.quote.total)}</span></div>
            </>
          ) : <p className="text-slate-300">{a.quote_notice}</p>}
        </div>
        <p className="mt-4 rounded-xl border border-amber-400/30 bg-amber-400/10 p-4 text-xs font-semibold leading-relaxed text-amber-100" data-testid="acceptance-clause">{a.clause}</p>
        <button type="button" data-testid="acceptance-open-pdf" className="mt-3 inline-flex items-center gap-1 text-sm text-primary hover:underline"
          onClick={() => window.open(`${API}/public/receipt/${data.public_token}?type=delivery`, "_blank")}>
          <FileText className="h-4 w-4" /> Apri il modulo completo (PDF)
        </button>
        <label className="mt-4 flex cursor-pointer items-start gap-3 text-sm">
          <Checkbox data-testid="acceptance-checkbox" checked={checked} onCheckedChange={(v) => setChecked(!!v)} className="mt-0.5 border-white/40" />
          <span>Ho letto e accetto i termini del modulo di accettazione</span>
        </label>
        {error && <div className="mt-3 text-sm text-rose-300">{error}</div>}
        <Button data-testid="acceptance-accept-btn" disabled={!checked || busy} onClick={accept} className="mt-5 w-full">
          {busy ? "Attendere…" : "Accetto e proseguo"}
        </Button>
      </div>
    </div>
  );
};

const Row = ({ label, value }) => (
  <div className="flex justify-between gap-4"><span className="text-slate-400">{label}</span><span className="text-right font-medium">{value}</span></div>
);
